export default __webpack_public_path__ + "static/media/img4.3e0bc11d.jpg";